import React, { useContext } from 'react';
import { CalculatorAdvancedMode } from '../classes/CalculatorMode';
import { CalculatorAdvancedModeContext } from '../contexts/CalculatorContext';

export function AdvancedMode(): JSX.Element {
    const advancedMode = useContext(CalculatorAdvancedModeContext)!;

    return (
        <label id="selection-mode">
            <select value={advancedMode[0]}
                    className="purple"
                    onChange={e => {
                        advancedMode[1](e.currentTarget.value === CalculatorAdvancedMode.Simple
                            ? CalculatorAdvancedMode.Simple
                            : CalculatorAdvancedMode.Advanced);
                    }}>
                <option value={CalculatorAdvancedMode.Simple}>{CalculatorAdvancedMode.Simple}</option>
                <option value={CalculatorAdvancedMode.Advanced}>{CalculatorAdvancedMode.Advanced}</option>
            </select>
        </label>
    );
}
